import { BaseRouteService } from 'core/services';

class FulfillmentPasswordRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-password';
	}

	changePassword() {
		return super.create(`${this.base}/change`);
	}

	sendResetPasswordCode(params) {
		return super.create(`${this.base}/send-reset-code`, params);
	}

	sendResetPasswordEmail(params) {
		return super.create(`${this.base}/send-reset-email`, params);
	}

	resendResetPasswordEmail(params) {
		return super.create(`${this.base}/resend-reset-email`, params);
	}

	resetPassword(params) {
		return super.create(`${this.base}/reset-password`, params);
	}
}

export default FulfillmentPasswordRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/FulfillmentPasswordRouteService.js